import { LightSwitch } from "@components/utilities";
import { type TagBasedOrderExclusion } from "@north-beam/nb-common";
import { Select } from "@shared/selects";
import { TextInput } from "@shared/text-input";

import { TAG_LOGIC, TAG_TYPES } from "./const";

type Props = {
  loading: boolean;
  updateTagFilters: (arg0: TagBasedOrderExclusion) => void;
  removeTagFilters: () => void;
  tagFilter: TagBasedOrderExclusion;
};

export const TagBasedOrderRow = ({
  tagFilter,
  loading,
  updateTagFilters,
  removeTagFilters,
}: Props) => {
  return (
    <tr className="odd:bg-cosmic-5 border-b border-b-gray-2">
      <td className="py-1 px-2 border-r border-r-gray-2">
        <div className="flex-center">
          <LightSwitch
            size="medium"
            isSet={tagFilter.active}
            disabled={loading || !tagFilter.name || !tagFilter.tagType}
            onChange={() =>
              updateTagFilters({
                ...tagFilter,
                active: !tagFilter.active,
              })
            }
            id={"light-switch" + tagFilter.name + Math.random()}
          />
        </div>
      </td>
      <td className="border-r border-r-gray-2">
        <Select
          className="border-0 bg-transparent rounded-none"
          options={TAG_TYPES}
          value={tagFilter.tagType}
          onChange={(tagType) => {
            updateTagFilters({ ...tagFilter, tagType });
          }}
        />
      </td>
      <td className="border-r border-r-gray-2">
        <Select
          className="border-0 bg-transparent rounded-none"
          options={TAG_LOGIC}
          value={tagFilter.tagLogic || "is"}
          onChange={(tagLogic) => {
            updateTagFilters({ ...tagFilter, tagLogic });
          }}
        />
      </td>
      <td className="py-1 px-2 flex items-center">
        <TextInput
          className="text-sm"
          value={tagFilter.name}
          disabled={loading}
          onChange={({ target }) =>
            updateTagFilters({
              ...tagFilter,
              name: target.value,
            })
          }
        />
        <div className="cursor-pointer" onClick={removeTagFilters}>
          <i className="fa-regular fa-times-circle ml-4 mr-2 text-mars" />
        </div>
      </td>
    </tr>
  );
};
